import { useEffect, useSyncExternalStore } from "react";
import { Alert, Snackbar } from "@mui/material";
import "../ErrorMessage/ErrorMessage.css";
import {
  dismissPersistentSnackbar,
  getPersistentSnackbar,
  subscribePersistentSnackbar,
} from "./persistentErrorSnackbarStore";

export default function PersistentErrorSnackbar() {
  const snackbar = useSyncExternalStore(
    subscribePersistentSnackbar,
    getPersistentSnackbar,
    getPersistentSnackbar,
  );

  useEffect(() => dismissPersistentSnackbar, []);

  const handleClose = (_event?: any, reason?: string) => {
    if (reason === "clickaway") return;
    dismissPersistentSnackbar();
  };

  return (
    <Snackbar
      open={Boolean(snackbar?.message)}
      // No autoHideDuration on purpose - this snackbar waits for the user.
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        className="cookieAlert"
        severity={snackbar?.type ?? "error"}
        sx={{ width: "100%", marginBottom: 1 }}
        onClose={handleClose}
      >
        <>{snackbar?.message}</>
      </Alert>
    </Snackbar>
  );
}
